import { colors } from "oolib";
const {black_opacity50} = colors
export const inlineStyleMap = {
  'UNDERLINE': {
    textDecoration: 'underline',
    textDecorationThickness: '0.2rem',
    textDecorationColor: black_opacity50,
  },
};
